import { setTrackSceneSource } from "./src/analytics.js";

export const tourFunctions = {};
/*____________ Tour Functions ____________*/
tourFunctions.enterVr = () => {
  window.CC.krpano.call("webvr.enterVR();");
};

tourFunctions.setStopUrl = (scene = null) => {
  if (!scene) {
    scene = tourFunctions.currentScene.getScene();
  }
  const sceneIndex = scene.index + 1;
  const url = window.location.href.split("?")[0].split("#")[0];
  const scenePath = `/stop/${sceneIndex}`;
  window.location.hash = scenePath;
}

tourFunctions.setHotspotUrl = (hotspotId) => {
  if( !hotspotId ) return;
  const url = window.location.href.split("?")[0].split("#")[0];
  const hotspotPath = `/hotspot/${hotspotId}`;
  window.location.hash = hotspotPath;
}

tourFunctions.focus = () => {
  document.querySelector("#krpanoSWFObject").focus();
};

tourFunctions.convertColor = (color) => {
  color = color || "0x000000";
  if (color.startsWith("#")) {
    color = "0x" + color.slice(1);
  }
  return color;
};

tourFunctions.getScenes = () => {
  const scenes = window.CC.krpano.get("scene").getArray();
  return scenes;
};

tourFunctions.switchView = () => {
  expandedTour = !expandedTour;
  expandedMap = !expandedMap;
  expandedTour ? showHotspots() : hideHotspots();
  setMapZoom();
};

tourFunctions.setMapZoom = () => {
  let zoomExpandedMap = 16.75;
  let zoomMiniMap = 15;
  let zoomLevel = expandedMap ? zoomExpandedMap : zoomMiniMap;
  tourFunctions.mapZoom.set(zoomLevel);
  return zoomLevel;
};

tourFunctions.showHotspots = () => {
  console.log("show_hotspots");
  window.CC.krpano.call(
    "for(copy(i,hotspot.count), i GE 0, dec(i), set(hotspot[get(i)].visible, true); );"
  );
};

tourFunctions.hideHotspots = () => {
  console.log("hide_hotspots");
  window.CC.krpano.call(
    "for(copy(i,hotspot.count), i GE 0, dec(i), set(hotspot[get(i)].visible, false); );"
  );
};

tourFunctions.setBrowserLocationWithSceneIndex = () => {
  const sceneIndex = window.CC.krpano.get("scene[get(xml.scene)].index") + 1;
  const url = window.location.href.split("?")[0].split("#")[0];
  const scenePath = `#/stop/${sceneIndex}`;
  // Replace the Location URL
  window.history.replaceState(null, "", `${url}${scenePath}`);
};

tourFunctions.getSceneIndexFromBrowserLocation = () => {
  const sceneIndex = window.location.hash.split("/")[2];
  return sceneIndex;
}

tourFunctions.nextScene = (trackingSource = 'next') => {
  window.CC.pendingSceneSource = trackingSource;
  window.CC.krpano.call("nextscene_loop(+1)");
};

tourFunctions.prevScene = (trackingSource = 'prev') => {
  window.CC.pendingSceneSource = trackingSource;
  window.CC.krpano.call("nextscene_loop(-1)");
};

tourFunctions.loadFirstScene = (trackingSource = 'krpano') => {
  window.CC.pendingSceneSource = trackingSource;
  window.CC.krpano.call("loadscene(get(scene[0].name), NULL, MERGE, SLIDEBLEND(1.0, 90, 0.5, linear) );");
};

tourFunctions.loadSceneByIndex = (index, trackingSource) => {
  window.CC.pendingSceneSource = trackingSource;
  window.CC.krpano.call(`loadscene(get(scene[${index}].name), NULL, MERGE, SLIDEBLEND(1.0, 90, 0.5, linear) )`);
};

tourFunctions.loadScene = (scene, trackingSource) => {
  let sceneName = typeof scene === "string" ? scene : scene.name;
  window.CC.pendingSceneSource = trackingSource;
  window.CC.krpano.call(
    `loadscene(${sceneName}, NULL, MERGE, SLIDEBLEND(1.0, 90, 0.5, linear) )`
  );
};

tourFunctions.parseContent = (content) => {
  if (typeof content !== "string") {
    return "";
  }
  return content.replaceAll("[", "<").replaceAll("]", ">");
};

tourFunctions.getFirstScene = () => {
  return window.CC.krpano.get("scene[0]");
};

tourFunctions.getFirstSceneName = () => {
  return window.CC.krpano.get("scene[0].name");
};
tourFunctions.getAutoNavStatus = () => {
  return !!window.CC.krpano.get("autoNavActive");
};

tourFunctions.setAutoNavInterval = (interval) => {
  window.CC.krpano.set("autoNavInterval", interval);
}

tourFunctions.startAutoNav = (interval) => {
  if (interval) window.CC.krpano.set("autoNavInterval", interval);
  window.CC.krpano.set("autoNavActive", true);
  window.CC.krpano.call("autonav()");
};

tourFunctions.stopAutoNav = () => {
  window.CC.krpano.set("autoNavActive", false);
};

tourFunctions.toggleAutoNav = () => {
  const isActive = tourFunctions.getAutoNavStatus();
  window.CC.krpano.set("autoNavActive", !isActive);
  window.CC.krpano.call("autonav()");
};

tourFunctions.currentScene = {
  getTitle: () => {
    return window.CC.krpano.get("scene[get(xml.scene)].title");
  },
  getScene: () => {
    return window.CC.krpano.get("scene[get(xml.scene)]");
  },

  getName: () => {
    return window.CC.krpano.get("xml.scene");
  },

  getIndex: () => {
    return window.CC.krpano.get("scene[get(xml.scene)].index");
  },

  getId: () => {
    return window.CC.krpano.get("scene[get(xml.scene)].id");
  },

  getHotspots: () => {
    let validStyles = ["skin_hotspotstyle", "skin_hotspotstyle_balloon"];

    let hotspots = window.CC.krpano
      .get("hotspot")
      .getArray()
      .filter((hs) => {
        return validStyles.includes(hs.style);
      });

    return hotspots;
  },

  getHotspot: (name) => {
    return window.CC.krpano.get(`hotspot[${name}]`);
  },

  getGallery: (name) => {
    let galleryObj = window.CC.krpano.get(`gallery[${name}]`);
    if (galleryObj === null) {
      return null;
    }
    let gallery = galleryObj.img.getArray().map((galleryImg) => {
      return {
        src: galleryImg.url.replace("%SWFPATH%", "."),
        alt: galleryImg.alt,
      };
    });
    return gallery;
  },

  removeHotspot: (hs) => {
    window.CC.krpano.call("removehotspot(" + hs.name + ")");
  },

  getContent: () => {
    return window.CC.krpano.get("xml").content;
  },

  getLogo: () => {
    return window.CC.krpano.get("scene[get(xml.scene)].logo");
  },

  getView: () => {
    return window.CC.krpano.get("xml.view");
  },

  getCurrentView: () => {
    return window.CC.krpano.get("view");
  },

  getPosition: () => {
    let view = tourFunctions.currentScene.getCurrentView();
    let position = { ath: view.hlookat, atv: view.vlookat };
    return position;
  },
  // https://krpano.com/docu/plugininterface/#krpano.webGL.makeScreenshot
  screenshot(
    width = 0,
    height = 0,
    hotspots = false,
    type = "jpeg",
    jpegquality = 0.85,
    crop = null,
    sizeinfo = null,
    cache = null,
  ) {
    return window.CC.krpano
      .get("global")
      .webGL.makeScreenshot(
        width,
        height,
        hotspots,
        type,
        jpegquality,
        crop,
        sizeinfo,
        cache,
      );
  },
  panUp: (amount) => {
    window.CC.krpano.call(
      `calc(view.vlookat, get(view.vlookat) - ${amount} );`
    );
  },

  panDown: (amount) => {
    window.CC.krpano.call(
      `calc(view.vlookat, get(view.vlookat) + ${amount} );`
    );
  },

  panLeft: (amount) => {
    window.CC.krpano.call(
      `calc(view.hlookat, get(view.hlookat) - ${amount} );`
    );
  },

  panRight: (amount) => {
    window.CC.krpano.call(
      `calc(view.hlookat, get(view.hlookat) + ${amount} );`
    );
  },
};

tourFunctions.setupFonts = (fonts) => {
  for (let key in fonts) {
    setStyleVar(kebabCase(key), fonts[key]);
  }
};

tourFunctions.setupColors = (colors) => {
  for (let key in colors) {
    // remove alpha channel
    let colorOnly = colors[key] & 0xffffff;
    let rgb = hexToRgbString(colorOnly);
    let hex = hexToString(colors[key]);

    setStyleVar(kebabCase(key) + "-rgb", rgb);
    setStyleVar(kebabCase(key), hex);

    colors[key + "Rgb"] = rgb;
    colors[key + "Hex"] = hex;
  }
};

// Private functions
function hexToRgb(hex) {
  let r = hex >> 16;
  let g = (hex >> 8) & 0xff;
  let b = hex & 0xff;
  return [r, g, b];
}

function rgbToString(rgb) {
  return +rgb[0] + "," + rgb[1] + "," + rgb[2];
}

function hexToRgbString(hex) {
  let rgb = hexToRgb(hex);
  return rgbToString(rgb);
}

function hexToString(hex) {
  // if hex is a string (ie from json response)
  if (typeof hex === "string") {
    hex = parseInt(hex, 16);
  }
  // convert hex to string
  let str = hex.toString(16);
  // pad with leading zeros
  while (str.length < 6) {
    str = "0" + str;
  }

  // #rrggbb
  const hexColor = "#" + str.toUpperCase();
  return hexColor;
}

function setStyleVar(name, value) {
  if (!name.startsWith("--")) {
    name = "--" + name;
  }
  document.documentElement.style.setProperty(name, value);
}

function kebabCase(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
